import React, { useEffect, useState } from "react";
import Button from "../../../../../components/button/button.jsx";
import {Modal} from "../../../../../components/modal/modal.jsx";

const defaultRows = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const defaultCols = Array.from({ length: 24 }, (_, i) =>
    String(i).padStart(2, "0")
);

const emptyMatrix = () =>
    Array(7).fill(null).map(() => Array(24).fill(0));

const matrixToSet = matrix => {
    const set = new Set();
    matrix.forEach((row, r) =>
        row.forEach((v, c) => {
            if (Number(v) === 1) set.add(`${r}-${c}`);
        })
    );
    return set;
};

const setToMatrix = set => {
    const matrix = emptyMatrix();
    set.forEach(key => {
        const [r, c] = key.split("-").map(Number);
        if (matrix[r] && matrix[r][c] !== undefined) {
            matrix[r][c] = 1;
        }
    });
    return matrix;
};

const ScheduleModalAlarm = ({ open, setOpen, alarmActive, onSave }) => {
    const [isSelecting, setIsSelecting] = useState(false);
    const [period, setPeriod] = useState(new Set());

    useEffect(() => {
        if (Array.isArray(alarmActive)) {
            setPeriod(matrixToSet(alarmActive));
        } else {
            setPeriod(new Set());
        }
    }, [alarmActive, open]);

    useEffect(() => {
        document.addEventListener("mouseup", () => setIsSelecting(false));
        return () =>
            document.removeEventListener("mouseup", () => setIsSelecting(false));
    }, []);

    const toggleCell = (row, col) => {
        setPeriod(prev => {
            const next = new Set(prev);
            const key = `${row}-${col}`;
            next.has(key) ? next.delete(key) : next.add(key);
            return next;
        });
    };

    const toggleColumn = col => {
        setPeriod(prev => {
            const next = new Set(prev);
            defaultRows.forEach((_, row) => {
                const key = `${row}-${col}`;
                next.has(key) ? next.delete(key) : next.add(key);
            });
            return next;
        });
    };

    const toggleRow = row => {
        setPeriod(prev => {
            const next = new Set(prev);
            defaultCols.forEach((_, col) => {
                const key = `${row}-${col}`;
                next.has(key) ? next.delete(key) : next.add(key);
            });
            return next;
        });
    };

    const handleMouseDown = (row, col, isHeader = false, isSide = false) => {
        setIsSelecting(true);

        if (isHeader) toggleColumn(col);
        else if (isSide) toggleRow(row);
        else toggleCell(row, col);
    };

    const handleMouseEnter = (row, col, isHeader = false, isSide = false) => {
        if (!isSelecting) return;

        if (isHeader) toggleColumn(col);
        else if (isSide) toggleRow(row);
        else toggleCell(row, col);
    };

    const isCellSelected = (row, col) => period.has(`${row}-${col}`);

    const handleSave = () => {
        onSave(setToMatrix(period));
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} centered size="md" backdrop="static" keyboard={false} title={"Horários ativos"}>
            <Modal.Body className="p-2">
                <table className="border border-gray-200 w-full text-sm select-none !rounded-md">
                    <thead className="bg-gray-100">
                    <tr>
                        <th className="border border-gray-200" />
                        { defaultCols.map((col, i) => (
                            <th
                                key={i}
                                className="h-[40px] border border-gray-200 cursor-pointer font-semibold"
                                onMouseDown={() => handleMouseDown(null, i, true)}
                                onMouseEnter={() => handleMouseEnter(null, i, true)}
                                onMouseUp={() => setIsSelecting(false)}
                            >
                                <div className={"flex justify-center items-center w-full"}>
                                    { col }h
                                </div>
                            </th>
                        ))}
                    </tr>
                    </thead>

                    <tbody>
                    { defaultRows.map((row, r) => (
                        <tr key={r}>
                            <td
                                className="flex justify-center items-center border border-gray-200 cursor-pointer h-[40px]"
                                onMouseDown={() => handleMouseDown(r, null, false, true)}
                                onMouseEnter={() => handleMouseEnter(r, null, false, true)}
                                onMouseUp={() => setIsSelecting(false)}
                            >
                                { row }
                            </td>

                            { defaultCols.map((_, c) => (
                                <td
                                    key={c}
                                    className={`border border-gray-200 h-[40px] cursor-pointer ${
                                        isCellSelected(r, c) ? "bg-green-600" : ""
                                    }`}
                                    onMouseDown={() => handleMouseDown(r, c)}
                                    onMouseEnter={() => handleMouseEnter(r, c)}
                                    onMouseUp={() => setIsSelecting(false)}
                                />
                            ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
            </Modal.Body>

            <Modal.Footer className={"p-2"}>
                <Button target="primary" onClick={handleSave}>
                    Confirmar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ScheduleModalAlarm;